import Select from "react-select";
import { components as defaultComponents } from "react-select";

export const GeneralDropdown = ({
  options,
  placeholder,
  selectedOption,
  onChange,
  noOptionsMessage,
  errMsg,
  isClearable,
  isSearchable,
  noBorder,
  backgroundColor,
  width,
  disabled,
}) => {
  const border = errMsg ? "1px #dc354599 solid" : "1px #ddd solid";

  return (
    <div className="d-flex flex-column">
      <Select
        value={selectedOption}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        isClearable={isClearable || false}
        isSearchable={isSearchable || false}
        isDisabled={disabled}

        components={{ ...defaultComponents, IndicatorSeparator: () => null }}
        noOptionsMessage={() => noOptionsMessage}
        styles={{
          control: (base, state) => ({
            ...base,
            fontSize: "0.9rem",
            width: width || "11rem",
            border: noBorder ? "none" : border,
            boxShadow: "none",
            backgroundColor: backgroundColor ? backgroundColor : "none",
            "&:hover": {
              backgroundColor: "#eee",
            },
          }),
          menu: (base) => ({
            ...base,
            zIndex: 3,
            marginTop: 0,
          }),
          option: (base, state) => ({
            ...base,
            fontSize: "0.8rem",
            backgroundColor: state.isSelected
              ? "var(--s-purple-opacity-color)"
              : state.isFocused
              ? "#eee"
              : "white",
          }),
          noOptionsMessage: (base) => ({
            ...base,
            fontSize: "0.9rem",
            color: "#333",
            textAlign: "start",
          }),
        }}
      />
      <p className="m-0 text-12 text-center text-danger">{errMsg}</p>
    </div>
  );
};
